import APP from 'src/main.js'
import Event from './Event.js'

class IncomeReceived extends Event {
  get income_cancel(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.parent_id === this.id)&&(rel.child_type==='IncomeCancel'))||{}).child_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id === value)&&ev.id)
    } else {
      return null
    }
  }
  get income(){
    return (this.income_cancel||{}).income
  }
  get coract(){
    return (this.income||{}).coract
  }
  get coract_id(){
    return (this.income||{}).coract_id
  }
  set coract_id(v){v}

  get linked(){
    return this.income_cancel != null
  }

  // Should always be linked
  get should_be_linked(){
    return true
  }
}
export default IncomeReceived
